import { ClienteVendaProdutoSecao } from '../../../../../../../types/cliente-venda';
import { CollapsibleSection } from '../../produtos/sections/collapsible-section';
import { formatPreco } from '../format';
import { Row } from './styles';

interface Props {
  data: ClienteVendaProdutoSecao;
}

export const ProdutoSection = ({ data }: Props) => (
  <CollapsibleSection
    title="Produto"
    defaultOpen
    testId="venda-section-produto"
  >
    <Row>
      <span>Nome</span>
      <span>{data.nome ?? '—'}</span>
    </Row>
    <Row>
      <span>ID</span>
      <span>{data.id ?? '—'}</span>
    </Row>
    {data.tipoDescricao && (
      <Row>
        <span>Tipo</span>
        <span>{data.tipoDescricao}</span>
      </Row>
    )}
    <Row>
      <span>Preço (catálogo)</span>
      <span>{formatPreco(data.preco, data.moedaSigla)}</span>
    </Row>
    {data.produtor && (
      <Row>
        <span>Produtor / Seller</span>
        <span>
          {data.produtor.nome} {data.produtor.sobrenome ?? ''} ·{' '}
          {data.produtor.email}
        </span>
      </Row>
    )}
  </CollapsibleSection>
);
